import { render, staticRenderFns } from "./dangun.vue?vue&type=template&id=1b96d30e&scoped=true&"
import script from "./dangun.vue?vue&type=script&lang=js&"
export * from "./dangun.vue?vue&type=script&lang=js&"
import style0 from "./dangun.vue?vue&type=style&index=0&lang=less&"
import style1 from "./dangun.vue?vue&type=style&index=1&id=1b96d30e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b96d30e",
  null
  
)

export default component.exports